import { c as _c } from "react/compiler-runtime";
import type { DataIdentifier, Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
import useAutoDecryptControls from '@/entity/hooks/use-auto-decrypt-controls';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import { useEntityContext } from '@/entity/hooks/use-entity-context';
import type { EntityVault } from '@/types/vault';
import getRelevantDis from './utils/get-relevant-dis';
type UseDecryptOnboardingProps = {
  entity: Entity;
  onboarding: EntityOnboarding;
  onDecryptSuccess: (vault: VaultType) => void;
  vaultData: VaultType | undefined;
};

/** "Decrypt all" for the vault as of an onboarding. */
const useDecryptOnboarding = t0 => {
  const $ = _c(13);
  const {
    entity,
    onboarding,
    onDecryptSuccess,
    vaultData
  } = t0;
  const {
    kind: entityKind
  } = useEntityContext();
  const decryptControls = useDecryptControls();
  const autoDecryptControls = useAutoDecryptControls(entityKind);
  let t1;
  if ($[0] !== autoDecryptControls || $[1] !== decryptControls.isDecrypting || $[2] !== entity) {
    t1 = decryptControls.isDecrypting || autoDecryptControls.isEntityAutoDecrypting(entity.id);
    $[0] = autoDecryptControls;
    $[1] = decryptControls.isDecrypting;
    $[2] = entity;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isDecrypting = t1;
  let t2;
  if ($[4] !== decryptControls || $[5] !== entity || $[6] !== onDecryptSuccess || $[7] !== onboarding || $[8] !== vaultData?.vault) {
    t2 = async () => {
      const fields = getRelevantDis(Object.keys(vaultData?.vault || {}) as DataIdentifier[], onboarding.seqno?.toString());
      const response = await decryptControls.decrypt({
        entity,
        fields,
        reason: `Examining onboarding ${onboarding.id}`
      });
      const vault = Object.entries(response ?? {}).reduce((acc, t3) => {
        const [key, value] = t3;
        const di = onboarding.seqno ? key.split(":")[0] : key;
        acc[di] = value;
        return acc;
      }, {} as EntityVault);
      onDecryptSuccess({
        vault,
        transforms: {}
      });
    };
    $[4] = decryptControls;
    $[5] = entity;
    $[6] = onDecryptSuccess;
    $[7] = onboarding;
    $[8] = vaultData?.vault;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const decrypt = t2;
  let t3;
  if ($[10] !== decrypt || $[11] !== isDecrypting) {
    t3 = {
      decrypt,
      isDecrypting
    };
    $[10] = decrypt;
    $[11] = isDecrypting;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default useDecryptOnboarding;